<script lang="ts" setup>
import { i18n } from '@/i18n';
import TableHead from '../TableHead.vue';
import { TableContentProperty } from '../../interface/tableContentHeaders';
import ArrowIcon from '../../components/ArrowIcon.vue';
import { IYearMonth } from '@/coreDomainsModule/date';
import { ForecastDiffLastMonthTableContentViewModel } from './forecastDiffLastMonthTableContentViewModel';
import { computed } from 'vue';
import { ForecastDiffLastMonthService } from './domains/services/forecastDIffLastMonthService';
// props
const props = withDefaults(
  defineProps<{
    header: TableContentProperty;
    headerIndex: number;
    accumulationTableContentWidth: number;
    isVariableWidth: boolean;
    isAllSelected: boolean;
    stableColumnCount: number;
    forecastStartYearMonth?: IYearMonth;
  }>(),
  {
    forecastStartYearMonth: undefined,
  }
);
const forecastDiffLastMonthTableCellVM = new ForecastDiffLastMonthTableContentViewModel();

// emits
const emits = defineEmits<{
  (e: 'onClickSort', index: number, key: TableContentProperty, isAsc: boolean): void;
  (e: 'onMousedownResizer', event: MouseEvent, headerIndex: number): void;
}>();
//変数
const t = i18n.t;

const columnType = computed(() => {
  return ForecastDiffLastMonthService.getColumnType(props.header.key);
});

/**
 * ソートアイコンクリック時
 */
const onClickedSort = () => {
  emits('onClickSort', props.headerIndex, props.header, props.header.sortOption.isAsc);
};
</script>

<template>
  <TableHead
    class="forecast-diff-header-container"
    :class="[
      forecastDiffLastMonthTableCellVM.isSticky(stableColumnCount, headerIndex) ? 'sticky-content' : '',
      columnType === 'diffAmount' ? 'forecast-diff-header-container--border-right' : '',
    ]"
    :style="{
      left: forecastDiffLastMonthTableCellVM.calcStickyDiff(stableColumnCount, headerIndex, accumulationTableContentWidth),
    }"
    :index="headerIndex"
    :resizable="
      // 幅可変な列 && 固定する列に含まれていない -> 可変幅
      header.isVariableWidth && !forecastDiffLastMonthTableCellVM.isSticky(stableColumnCount, headerIndex)
    "
    @on-mousedown-resizer="($event) => emits('onMousedownResizer', $event, headerIndex)"
  >
    <div class="forecast-diff-header">
      <div class="forecast-diff-header__current-month">
        <!-- 今月の場合のみ、年月yyyy/MMを入れる -->
        {{
          columnType === 'currentMonthAmount' ? t(forecastDiffLastMonthTableCellVM.getHeaderText(header.key, forecastStartYearMonth)) : ''
        }}
      </div>
      <template v-if="header.sortOption.isSortable">
        <div class="table-header__sortable-content forecast-diff-header__column-type">
          <div class="table-header__text">{{ forecastDiffLastMonthTableCellVM.getForecastDiffHeaderText(columnType) }}</div>
          <ArrowIcon :asc="header.sortOption.isAsc" @on-click="emits('onClickSort', headerIndex, header, header.sortOption.isAsc)" />
        </div>
      </template>
      <template v-else>
        <div class="table-header__text">{{ forecastDiffLastMonthTableCellVM.getForecastDiffHeaderText(columnType) }}</div>
      </template>
    </div>
  </TableHead>
</template>

<style scoped lang="scss">
.forecast-diff-header-container {
  &--border-right {
    border-right: 1px solid $borderSecondary;
  }
}
.forecast-diff-header {
  height: 100%;
  display: grid;
  grid-template-rows: repeat(2, minmax(0, 12px));
  gap: 4px;
  padding-top: 4px;
  padding-bottom: 4px;
  justify-items: center;
  align-content: space-between;

  &__current-month {
    font-size: $fontSizeSS;
    font-weight: 400;
    color: $textDefault;
    height: 100%;
    line-height: 12px;
  }

  &__column-type {
    font-size: $fontSizeSS;
    font-weight: 700;
    color: $textDefault;
    height: 100%;
    line-height: 12px;
  }
}
</style>
